import request from '@/utils/request'


export function upDateTaskType(data) {
  return request({
    url: '/task/task/upDateTaskType',
    method: 'POST',
    data,
  })
}

/**
 * 查询任务
 * @param {Object} params 
 * @returns 
 */
export function listTask(params) {
  return request({
    url: '/task/task/list',
    method: 'GET',
    params,
  })
}

/**
 * 查询单个任务
 * @param {Object} params 
 * @returns 
 */
export function getTaskInfo(_id) {
  return request({
    url: '/task/task/findOne',
    method: 'GET',
    params: {
      _id,
    },
  })
}

/**
 * 添加任务
 * @param {Object} data 
 * @returns 
 */
export function addTask(data) {
  return request({
    url: '/task/task/insert',
    method: 'POST',
    data,
  })
}

/**
 * 删除任务
 * @param {Object} data 
 * @returns 
 */
 export function deleteTask(task) {
  return request({
    url: '/task/task/deleteTask',
    method: 'POST',
    data:task
  })
}


/**
 * 修改任务
 * @param {Object} data 
 * @returns 
 */
export function updateTask(data) {
  return request({
    url: '/task/task/update',
    method: 'POST',
    data,
  })
}

/**
 * 修改任务任务排序
 * @param {Object} data 
 * @returns 
 */
export function updateTaskSort(data) {
  return request({
    url: '/task/task/updateSort',
    method: 'POST',
    data,
  })
}

/**
 * 复制任务
 * @param {Object} data 
 * @returns 
 */
export function copyTask(data) {
  return request({
    url: '/task/task/copyTask',
    method: 'POST',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function removeTask(data) {
  return request({
    url: '/task/task/remove',
    method: 'POST',
    data,
  })
}


/**
 * 添加任务
 * @param {Object} data 
 * @returns 
 */
export function getTaskById(data) {
  return request({
    url: '/task/task/getById',
    method: 'get',
    data,
  })
}





/**
 * 插入节点组织树接口
 * @param {Object} data 
 * @returns 
 */
 export function saveTreeJsonData(data) {
  return request({
    url: '/task/task/insertTreeJsonData',
    method: 'POST',
    data:{
      taskId:data.taskId,     
      jsonData:data.jsonData,
      // msgArr:data.msgArr
    }
  })
}

/**
 * 插入节点组织树接口
 * @param {Object} data 
 * @returns 
 */
 export function queryTreeJsonData(taskId) {
  return request({
    url: '/task/task/queryTreeJsonData',
    method: 'GET',
    params: {
      taskId,
    },
  })
}

/**
 * 插入节点组织树接口
 * @param {Object} data 
 * @returns 
 */
 export function setConfigDatas(params) {
  return request({
    url: '/task/task/setConfigDatas',
    method: 'POST',
    data:{
      taskEditor:params.taskEditor,     
      // taskInfo:params.taskInfo
    }
  })
}



